<login-header></login-header>

<div class="gdpr-hero" style="background-image: url('../assets/images/gdpr-hero-bg.webp');">
    <div class="content-width text-center">
        <div class="gdpr-content">
            <img src="../assets/images/ccpa-circle.webp" alt="CCPA Image">
            <h1 class="mb-3">Family Central is CCPA ready.</h1>
            <p class="mb-3">The California Consumer Privacy Act (CCPA), enacted in 2018 and taking effect on Jan. 1, 2020, gives consumers in California additional rights protections regarding how businesses may use their personal information. Tho CCPA imposes many obligations on businesses that are similar to those required by the General Data Protection Regulation (GDPR)</p>
        </div>
    </div>
</div>

<app-footer (showPrice)="showPricing()"></app-footer>

<ng-template #pricing>
    <app-pricing (onCancel)="onClose()"></app-pricing>
</ng-template>